import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../configs/urlConfig";
import Utils from "../utils";
axios.defaults.withCredentials = true;

function EditInvestmentModal({ onClose, onSave, investment }) {

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    existing_customer: "", // za select
    first_name: "",        // ako dodaje novu
    deposit_date: new Date().toISOString().split("T")[0], // default na danas
    invested_amount: "",
    payout: "",
  });
  useEffect(() => {
    if (investment) {
      setForm({
        ...form,
        existing_customer: investment.customer_id, // za select
        investment_id: investment.investment_id,
        first_name: "",        // ako dodaje novu
        deposit_date: new Date(investment.deposit_date).toISOString().split("T")[0], // default na danas
        invested_amount: investment.invested_amount,
        payout: investment.payout,
      })

    }
  }, [investment])

  // Fetch existing customers


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };


  const deleteInvestment = async () => {
    try {

      const response = await axios.delete(`${API}/investment_delete/${investment.investment_id}/`, Utils.getUserToken());

      if (response.data.success) {
        onSave && onSave(response.data.customer);
        onClose();
      } else {
        setError(response.data.error || "Greška prilikom čuvanja mušterije");
      }
    } catch (err) {
      console.error(err);
      setError("Greška prilikom čuvanja mušterije");
    } finally {
      setLoading(false);
    }
  }

  const handleDelete = () => {
    const confirmed = window.confirm(
      "Da li ste sigurni da želite da izbrišete ovu stavku?"
    );

    if (confirmed) {
      deleteInvestment(); // funkcija za brisanje
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const payload = { ...form, action: 'edit' };

      // Ako je izabran existing_customer, ignorisi first_name
      if (form.existing_customer) {
        delete payload.first_name;
      }

      const response = await axios.post(`${API}/investment-edit/`, payload, Utils.getUserToken());

      if (response.data.success) {
        onSave && onSave(response.data.customer);
        onClose();
      } else {
        setError(response.data.error || "Greška prilikom čuvanja mušterije");
      }
    } catch (err) {
      console.error(err);
      setError("Greška prilikom čuvanja mušterije");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      aria-labelledby="customerModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
        <div className="modal-content app-modal">
          <div className="modal-header border-0">
            <div>
              <h2 className="modal-title fs-4" id="customerModalLabel">
                Izmeni {investment.customer_name} {investment.invested_date}
              </h2>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Zatvori"
            ></button>
          </div>

          {error && <div className="alert alert-danger m-3">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="modal-body pt-0">
              <div className="row g-3">


                <div className="col-12 col-md-6">
                  <label className="form-label">Ime</label>
                  <input
                    readOnly
                    type="text"
                    name="first_name"
                    className="form-control"
                    value={investment.customer_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">Datum uplate</label>
                  <input
                    type="date"
                    name="deposit_date"
                    className="form-control"
                    value={form.deposit_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label">Iznos</label>
                  <input
                    type="number"
                    name="invested_amount"
                    className="form-control"
                    value={form.invested_amount}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label">Povrat</label>
                  <input
                    type="number"
                    name="payout"
                    className="form-control"
                    value={form.payout}
                    onChange={handleChange}
                  />
                </div>
              </div>

            </div>

            <div className="modal-footer border-0 modal-footer-stack">

              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
              >
                Zatvori
              </button>
              <button
                className="btn btn-danger"
                onClick={handleDelete}
              >
                Izbriši
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Čuvanje..." : "Izmeni Uplatu"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditInvestmentModal;